import gql from 'graphql-tag'

export const TablesGQL = {
    TABLES_FOR_PROFILE: gql`query TablesForProfile($profileId: ID!) {
        tablesForProfile(profileId: $profileId)
    }`,

    DATA_FOR_TABLE_AND_PROFILE: gql`query DataForTableAndProfile($profileId: ID!, $tableName: String!, $query: QueryInput, $lastEvaluatedKey: String){
        dataForTableAndProfile(profileId: $profileId, tableName: $tableName, query: $query, lastEvaluatedKey: $lastEvaluatedKey)
    }`,

    DESCRIBE_TABLE: gql`query DescribeTable($profileId: ID!, $tableName: String!){
        describeTable(profileId: $profileId, tableName: $tableName)
    }`,

    SAVE_DOCUMENTS: gql`mutation SaveDocuments($profileId: ID!, $tableName: String!, $documents: [AWSJSON!]!){
        saveDocuments(profileId: $profileId, tableName: $tableName, documents: $documents)
    }`,

    DELETE_DOCUMENTS: gql`mutation DeleteDocuments($profileId: ID!, $tableName: String!, $documents: [AWSJSON!]!){
        deleteDocuments(profileId: $profileId, tableName: $tableName, documents: $documents)
    }`
}
